import {
  Companion_getInstance14au1t142dbyp as Companion_getInstance,
  Owner3o3y53m8go5cb as Owner,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  EmailAddress1n0o8cqqfp9qz as EmailAddress,
  PhoneNumber2x98iurnwvnj9 as PhoneNumber,
} from '../../../lightning-server-shared/com/lightningkite/StringAlts.mjs';
import { Addresscpovxna1tjmg as Address } from './supportModels.mjs';
import { LocalDate31mqn6zavbpi8 as LocalDate } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import {
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
  UUID21wrnrlmk5y1y as UUID,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { ServerFile1t91jzpzoixwe as ServerFile } from '../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ssn(_this__u8e3s4) {
  return _this__u8e3s4.prop(Owner_ssn_getInstance());
}
function get_ownership(_this__u8e3s4) {
  return _this__u8e3s4.prop(Owner_ownership_getInstance());
}
function get_legalFirstName(_this__u8e3s4) {
  return _this__u8e3s4.prop(Owner_legalFirstName_getInstance());
}
function get_legalLastName(_this__u8e3s4) {
  return _this__u8e3s4.prop(Owner_legalLastName_getInstance());
}
function get_email(_this__u8e3s4) {
  return _this__u8e3s4.prop(Owner_email_getInstance());
}
function get_phoneNumber(_this__u8e3s4) {
  return _this__u8e3s4.prop(Owner_phoneNumber_getInstance());
}
function get_address(_this__u8e3s4) {
  return _this__u8e3s4.prop(Owner_address_getInstance());
}
function get_title(_this__u8e3s4) {
  return _this__u8e3s4.prop(Owner_title_getInstance());
}
function get_birthDate(_this__u8e3s4) {
  return _this__u8e3s4.prop(Owner_birthDate_getInstance());
}
function prepareOwnerFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [Owner__id_getInstance(), Owner_legalFirstName_getInstance(), Owner_legalLastName_getInstance(), Owner_email_getInstance(), Owner_phoneNumber_getInstance(), Owner_address_getInstance(), Owner_title_getInstance(), Owner_ssn_getInstance(), Owner_ssnDisplay_getInstance(), Owner_ownership_getInstance(), Owner_birthDate_getInstance(), Owner_document_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function Owner_ssn$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(7);
}
function Owner_ssn$_get_name_$ref_fslz81() {
  return (p0) => p0.i20();
}
function Owner_ssn$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Owner_ssn$_get_serializer_$ref_v6100m() {
  return (p0) => p0.h2j();
}
function Owner_ssn$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(7);
}
function Owner_ssn$_get_annotations_$ref_c50om2() {
  return (p0) => p0.bz();
}
var Owner_ssnClass;
function Owner_ssn() {
  if (Owner_ssnClass === VOID) {
    class $ {
      constructor() {
        Owner_ssn_instance = this;
        var tmp = this;
        tmp.m6s_1 = lazy(Owner_ssn$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n6s_1 = lazy(Owner_ssn$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o6s_1 = lazy(Owner_ssn$annotations$delegate$lambda);
        this.p6s_1 = '';
        this.q6s_1 = '""';
      }
      i20() {
        var tmp0 = this.m6s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Owner_ssn$_get_name_$ref_fslz81(), null);
        return tmp0.f2();
      }
      r6s(receiver) {
        return receiver.z6s_1;
      }
      k2j(receiver) {
        return this.r6s(receiver instanceof Owner() ? receiver : THROW_CCE());
      }
      e6t(receiver, value) {
        return receiver.f6t(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Owner() ? receiver : THROW_CCE();
        return this.e6t(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.n6s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Owner_ssn$_get_serializer_$ref_v6100m(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o6s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Owner_ssn$_get_annotations_$ref_c50om2(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Owner_ssn', VOID, VOID, [SerializableProperty()]);
    Owner_ssnClass = $;
  }
  return Owner_ssnClass;
}
var Owner_ssn_instance;
function Owner_ssn_getInstance() {
  if (Owner_ssn_instance === VOID)
    new (Owner_ssn())();
  return Owner_ssn_instance;
}
function Owner_ownership$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(9);
}
function Owner_ownership$_get_name_$ref_nqxy4w() {
  return (p0) => p0.i20();
}
function Owner_ownership$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Owner_ownership$_get_serializer_$ref_l2srft() {
  return (p0) => p0.h2j();
}
function Owner_ownership$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(9);
}
function Owner_ownership$_get_annotations_$ref_1yxxol() {
  return (p0) => p0.bz();
}
var Owner_ownershipClass;
function Owner_ownership() {
  if (Owner_ownershipClass === VOID) {
    class $ {
      constructor() {
        Owner_ownership_instance = this;
        var tmp = this;
        tmp.g6t_1 = lazy(Owner_ownership$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h6t_1 = lazy(Owner_ownership$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i6t_1 = lazy(Owner_ownership$annotations$delegate$lambda);
        this.j6t_1 = 100;
        this.k6t_1 = '100';
      }
      i20() {
        var tmp0 = this.g6t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Owner_ownership$_get_name_$ref_nqxy4w(), null);
        return tmp0.f2();
      }
      r6s(receiver) {
        return receiver.b6t_1;
      }
      k2j(receiver) {
        return this.r6s(receiver instanceof Owner() ? receiver : THROW_CCE());
      }
      l6t(receiver, value) {
        return receiver.f6t(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Owner() ? receiver : THROW_CCE();
        return this.l6t(tmp, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.h6t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Owner_ownership$_get_serializer_$ref_l2srft(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i6t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Owner_ownership$_get_annotations_$ref_1yxxol(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Owner_ownership', VOID, VOID, [SerializableProperty()]);
    Owner_ownershipClass = $;
  }
  return Owner_ownershipClass;
}
var Owner_ownership_instance;
function Owner_ownership_getInstance() {
  if (Owner_ownership_instance === VOID)
    new (Owner_ownership())();
  return Owner_ownership_instance;
}
function Owner_legalFirstName$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function Owner_legalFirstName$_get_name_$ref_6c2oit() {
  return (p0) => p0.i20();
}
function Owner_legalFirstName$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Owner_legalFirstName$_get_serializer_$ref_nnlg3i() {
  return (p0) => p0.h2j();
}
function Owner_legalFirstName$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function Owner_legalFirstName$_get_annotations_$ref_6wn8qu() {
  return (p0) => p0.bz();
}
var Owner_legalFirstNameClass;
function Owner_legalFirstName() {
  if (Owner_legalFirstNameClass === VOID) {
    class $ {
      constructor() {
        Owner_legalFirstName_instance = this;
        var tmp = this;
        tmp.m6t_1 = lazy(Owner_legalFirstName$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n6t_1 = lazy(Owner_legalFirstName$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o6t_1 = lazy(Owner_legalFirstName$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.m6t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Owner_legalFirstName$_get_name_$ref_6c2oit(), null);
        return tmp0.f2();
      }
      r6s(receiver) {
        return receiver.t6s_1;
      }
      k2j(receiver) {
        return this.r6s(receiver instanceof Owner() ? receiver : THROW_CCE());
      }
      e6t(receiver, value) {
        return receiver.f6t(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Owner() ? receiver : THROW_CCE();
        return this.e6t(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.n6t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Owner_legalFirstName$_get_serializer_$ref_nnlg3i(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o6t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Owner_legalFirstName$_get_annotations_$ref_6wn8qu(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Owner_legalFirstName', VOID, VOID, [SerializableProperty()]);
    Owner_legalFirstNameClass = $;
  }
  return Owner_legalFirstNameClass;
}
var Owner_legalFirstName_instance;
function Owner_legalFirstName_getInstance() {
  if (Owner_legalFirstName_instance === VOID)
    new (Owner_legalFirstName())();
  return Owner_legalFirstName_instance;
}
function Owner_legalLastName$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function Owner_legalLastName$_get_name_$ref_xkyrd1() {
  return (p0) => p0.i20();
}
function Owner_legalLastName$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Owner_legalLastName$_get_serializer_$ref_qaatia() {
  return (p0) => p0.h2j();
}
function Owner_legalLastName$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function Owner_legalLastName$_get_annotations_$ref_lec6g6() {
  return (p0) => p0.bz();
}
var Owner_legalLastNameClass;
function Owner_legalLastName() {
  if (Owner_legalLastNameClass === VOID) {
    class $ {
      constructor() {
        Owner_legalLastName_instance = this;
        var tmp = this;
        tmp.p6t_1 = lazy(Owner_legalLastName$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q6t_1 = lazy(Owner_legalLastName$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r6t_1 = lazy(Owner_legalLastName$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.p6t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Owner_legalLastName$_get_name_$ref_xkyrd1(), null);
        return tmp0.f2();
      }
      r6s(receiver) {
        return receiver.u6s_1;
      }
      k2j(receiver) {
        return this.r6s(receiver instanceof Owner() ? receiver : THROW_CCE());
      }
      e6t(receiver, value) {
        return receiver.f6t(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Owner() ? receiver : THROW_CCE();
        return this.e6t(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.q6t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Owner_legalLastName$_get_serializer_$ref_qaatia(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r6t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Owner_legalLastName$_get_annotations_$ref_lec6g6(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Owner_legalLastName', VOID, VOID, [SerializableProperty()]);
    Owner_legalLastNameClass = $;
  }
  return Owner_legalLastNameClass;
}
var Owner_legalLastName_instance;
function Owner_legalLastName_getInstance() {
  if (Owner_legalLastName_instance === VOID)
    new (Owner_legalLastName())();
  return Owner_legalLastName_instance;
}
function Owner_email$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(3);
}
function Owner_email$_get_name_$ref_6uviv7() {
  return (p0) => p0.i20();
}
function Owner_email$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Owner_email$_get_serializer_$ref_qcbhzw() {
  return (p0) => p0.h2j();
}
function Owner_email$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(3);
}
function Owner_email$_get_annotations_$ref_j5ytns() {
  return (p0) => p0.bz();
}
var Owner_emailClass;
function Owner_email() {
  if (Owner_emailClass === VOID) {
    class $ {
      constructor() {
        Owner_email_instance = this;
        var tmp = this;
        tmp.s6t_1 = lazy(Owner_email$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.t6t_1 = lazy(Owner_email$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.u6t_1 = lazy(Owner_email$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.s6t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Owner_email$_get_name_$ref_6uviv7(), null);
        return tmp0.f2();
      }
      v6t(receiver) {
        return receiver.v6s_1;
      }
      k2j(receiver) {
        return new (EmailAddress())(this.v6t(receiver instanceof Owner() ? receiver : THROW_CCE()));
      }
      w6t(receiver, value) {
        return receiver.f6t(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Owner() ? receiver : THROW_CCE();
        return this.w6t(tmp, value instanceof EmailAddress() ? value.a3n_1 : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.t6t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Owner_email$_get_serializer_$ref_qcbhzw(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.u6t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Owner_email$_get_annotations_$ref_j5ytns(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Owner_email', VOID, VOID, [SerializableProperty()]);
    Owner_emailClass = $;
  }
  return Owner_emailClass;
}
var Owner_email_instance;
function Owner_email_getInstance() {
  if (Owner_email_instance === VOID)
    new (Owner_email())();
  return Owner_email_instance;
}
function Owner_phoneNumber$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(4);
}
function Owner_phoneNumber$_get_name_$ref_qbngew() {
  return (p0) => p0.i20();
}
function Owner_phoneNumber$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Owner_phoneNumber$_get_serializer_$ref_c439xb() {
  return (p0) => p0.h2j();
}
function Owner_phoneNumber$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(4);
}
function Owner_phoneNumber$_get_annotations_$ref_yk5pnn() {
  return (p0) => p0.bz();
}
var Owner_phoneNumberClass;
function Owner_phoneNumber() {
  if (Owner_phoneNumberClass === VOID) {
    class $ {
      constructor() {
        Owner_phoneNumber_instance = this;
        var tmp = this;
        tmp.x6t_1 = lazy(Owner_phoneNumber$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y6t_1 = lazy(Owner_phoneNumber$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z6t_1 = lazy(Owner_phoneNumber$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.x6t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Owner_phoneNumber$_get_name_$ref_qbngew(), null);
        return tmp0.f2();
      }
      a6u(receiver) {
        return receiver.w6s_1;
      }
      k2j(receiver) {
        return new (PhoneNumber())(this.a6u(receiver instanceof Owner() ? receiver : THROW_CCE()));
      }
      b6u(receiver, value) {
        return receiver.f6t(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Owner() ? receiver : THROW_CCE();
        return this.b6u(tmp, value instanceof PhoneNumber() ? value.f3n_1 : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.y6t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Owner_phoneNumber$_get_serializer_$ref_c439xb(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z6t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Owner_phoneNumber$_get_annotations_$ref_yk5pnn(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Owner_phoneNumber', VOID, VOID, [SerializableProperty()]);
    Owner_phoneNumberClass = $;
  }
  return Owner_phoneNumberClass;
}
var Owner_phoneNumber_instance;
function Owner_phoneNumber_getInstance() {
  if (Owner_phoneNumber_instance === VOID)
    new (Owner_phoneNumber())();
  return Owner_phoneNumber_instance;
}
function Owner_address$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(5);
}
function Owner_address$_get_name_$ref_62rrp() {
  return (p0) => p0.i20();
}
function Owner_address$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Owner_address$_get_serializer_$ref_rdjlw() {
  return (p0) => p0.h2j();
}
function Owner_address$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(5);
}
function Owner_address$_get_annotations_$ref_7gytc0() {
  return (p0) => p0.bz();
}
var Owner_addressClass;
function Owner_address() {
  if (Owner_addressClass === VOID) {
    class $ {
      constructor() {
        Owner_address_instance = this;
        var tmp = this;
        tmp.c6u_1 = lazy(Owner_address$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d6u_1 = lazy(Owner_address$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e6u_1 = lazy(Owner_address$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.c6u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Owner_address$_get_name_$ref_62rrp(), null);
        return tmp0.f2();
      }
      r6s(receiver) {
        return receiver.x6s_1;
      }
      k2j(receiver) {
        return this.r6s(receiver instanceof Owner() ? receiver : THROW_CCE());
      }
      f6u(receiver, value) {
        return receiver.f6t(VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Owner() ? receiver : THROW_CCE();
        return this.f6u(tmp, value instanceof Address() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.d6u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Owner_address$_get_serializer_$ref_rdjlw(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e6u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Owner_address$_get_annotations_$ref_7gytc0(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Owner_address', VOID, VOID, [SerializableProperty()]);
    Owner_addressClass = $;
  }
  return Owner_addressClass;
}
var Owner_address_instance;
function Owner_address_getInstance() {
  if (Owner_address_instance === VOID)
    new (Owner_address())();
  return Owner_address_instance;
}
function Owner_title$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(6);
}
function Owner_title$_get_name_$ref_cntzax() {
  return (p0) => p0.i20();
}
function Owner_title$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Owner_title$_get_serializer_$ref_lwoyw0() {
  return (p0) => p0.h2j();
}
function Owner_title$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(6);
}
function Owner_title$_get_annotations_$ref_nrsh9g() {
  return (p0) => p0.bz();
}
var Owner_titleClass;
function Owner_title() {
  if (Owner_titleClass === VOID) {
    class $ {
      constructor() {
        Owner_title_instance = this;
        var tmp = this;
        tmp.g6u_1 = lazy(Owner_title$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h6u_1 = lazy(Owner_title$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i6u_1 = lazy(Owner_title$annotations$delegate$lambda);
        this.j6u_1 = '';
        this.k6u_1 = '""';
      }
      i20() {
        var tmp0 = this.g6u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Owner_title$_get_name_$ref_cntzax(), null);
        return tmp0.f2();
      }
      r6s(receiver) {
        return receiver.y6s_1;
      }
      k2j(receiver) {
        return this.r6s(receiver instanceof Owner() ? receiver : THROW_CCE());
      }
      e6t(receiver, value) {
        return receiver.f6t(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Owner() ? receiver : THROW_CCE();
        return this.e6t(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.h6u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Owner_title$_get_serializer_$ref_lwoyw0(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i6u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Owner_title$_get_annotations_$ref_nrsh9g(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Owner_title', VOID, VOID, [SerializableProperty()]);
    Owner_titleClass = $;
  }
  return Owner_titleClass;
}
var Owner_title_instance;
function Owner_title_getInstance() {
  if (Owner_title_instance === VOID)
    new (Owner_title())();
  return Owner_title_instance;
}
function Owner_birthDate$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(10);
}
function Owner_birthDate$_get_name_$ref_6au4i6() {
  return (p0) => p0.i20();
}
function Owner_birthDate$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[10];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Owner_birthDate$_get_serializer_$ref_lbff2j() {
  return (p0) => p0.h2j();
}
function Owner_birthDate$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(10);
}
function Owner_birthDate$_get_annotations_$ref_5gkevt() {
  return (p0) => p0.bz();
}
var Owner_birthDateClass;
function Owner_birthDate() {
  if (Owner_birthDateClass === VOID) {
    class $ {
      constructor() {
        Owner_birthDate_instance = this;
        var tmp = this;
        tmp.l6u_1 = lazy(Owner_birthDate$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m6u_1 = lazy(Owner_birthDate$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n6u_1 = lazy(Owner_birthDate$annotations$delegate$lambda);
        this.o6u_1 = null;
        this.p6u_1 = 'null';
      }
      i20() {
        var tmp0 = this.l6u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Owner_birthDate$_get_name_$ref_6au4i6(), null);
        return tmp0.f2();
      }
      r6s(receiver) {
        return receiver.c6t_1;
      }
      k2j(receiver) {
        return this.r6s(receiver instanceof Owner() ? receiver : THROW_CCE());
      }
      q6u(receiver, value) {
        return receiver.f6t(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Owner() ? receiver : THROW_CCE();
        return this.q6u(tmp, (value == null ? true : value instanceof LocalDate()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.m6u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Owner_birthDate$_get_serializer_$ref_lbff2j(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n6u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Owner_birthDate$_get_annotations_$ref_5gkevt(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Owner_birthDate', VOID, VOID, [SerializableProperty()]);
    Owner_birthDateClass = $;
  }
  return Owner_birthDateClass;
}
var Owner_birthDate_instance;
function Owner_birthDate_getInstance() {
  if (Owner_birthDate_instance === VOID)
    new (Owner_birthDate())();
  return Owner_birthDate_instance;
}
function Owner__id$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function Owner__id$_get_name_$ref_6vrt7f() {
  return (p0) => p0.i20();
}
function Owner__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Owner__id$_get_serializer_$ref_jvbede() {
  return (p0) => p0.h2j();
}
function Owner__id$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function Owner__id$_get_annotations_$ref_77i1qe() {
  return (p0) => p0.bz();
}
var Owner__idClass;
function Owner__id() {
  if (Owner__idClass === VOID) {
    class $ {
      constructor() {
        Owner__id_instance = this;
        var tmp = this;
        tmp.r6u_1 = lazy(Owner__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s6u_1 = lazy(Owner__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t6u_1 = lazy(Owner__id$annotations$delegate$lambda);
        this.u6u_1 = Companion_getInstance_0().k2p();
        this.v6u_1 = 'UUID.random()';
      }
      i20() {
        var tmp0 = this.r6u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Owner__id$_get_name_$ref_6vrt7f(), null);
        return tmp0.f2();
      }
      r6s(receiver) {
        return receiver.s6s_1;
      }
      k2j(receiver) {
        return this.r6s(receiver instanceof Owner() ? receiver : THROW_CCE());
      }
      w6u(receiver, value) {
        return receiver.f6t(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Owner() ? receiver : THROW_CCE();
        return this.w6u(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.s6u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Owner__id$_get_serializer_$ref_jvbede(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t6u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Owner__id$_get_annotations_$ref_77i1qe(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Owner__id', VOID, VOID, [SerializableProperty()]);
    Owner__idClass = $;
  }
  return Owner__idClass;
}
var Owner__id_instance;
function Owner__id_getInstance() {
  if (Owner__id_instance === VOID)
    new (Owner__id())();
  return Owner__id_instance;
}
function Owner_ssnDisplay$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(8);
}
function Owner_ssnDisplay$_get_name_$ref_z3tvil() {
  return (p0) => p0.i20();
}
function Owner_ssnDisplay$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Owner_ssnDisplay$_get_serializer_$ref_ugjk5o() {
  return (p0) => p0.h2j();
}
function Owner_ssnDisplay$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(8);
}
function Owner_ssnDisplay$_get_annotations_$ref_4qokoo() {
  return (p0) => p0.bz();
}
var Owner_ssnDisplayClass;
function Owner_ssnDisplay() {
  if (Owner_ssnDisplayClass === VOID) {
    class $ {
      constructor() {
        Owner_ssnDisplay_instance = this;
        var tmp = this;
        tmp.x6u_1 = lazy(Owner_ssnDisplay$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y6u_1 = lazy(Owner_ssnDisplay$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z6u_1 = lazy(Owner_ssnDisplay$annotations$delegate$lambda);
        this.a6v_1 = '';
        this.b6v_1 = '""';
      }
      i20() {
        var tmp0 = this.x6u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Owner_ssnDisplay$_get_name_$ref_z3tvil(), null);
        return tmp0.f2();
      }
      r6s(receiver) {
        return receiver.a6t_1;
      }
      k2j(receiver) {
        return this.r6s(receiver instanceof Owner() ? receiver : THROW_CCE());
      }
      e6t(receiver, value) {
        return receiver.f6t(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Owner() ? receiver : THROW_CCE();
        return this.e6t(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.y6u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Owner_ssnDisplay$_get_serializer_$ref_ugjk5o(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z6u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Owner_ssnDisplay$_get_annotations_$ref_4qokoo(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Owner_ssnDisplay', VOID, VOID, [SerializableProperty()]);
    Owner_ssnDisplayClass = $;
  }
  return Owner_ssnDisplayClass;
}
var Owner_ssnDisplay_instance;
function Owner_ssnDisplay_getInstance() {
  if (Owner_ssnDisplay_instance === VOID)
    new (Owner_ssnDisplay())();
  return Owner_ssnDisplay_instance;
}
function Owner_document$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(11);
}
function Owner_document$_get_name_$ref_j64jxw() {
  return (p0) => p0.i20();
}
function Owner_document$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[11];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Owner_document$_get_serializer_$ref_xazbad() {
  return (p0) => p0.h2j();
}
function Owner_document$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(11);
}
function Owner_document$_get_annotations_$ref_lx4vr3() {
  return (p0) => p0.bz();
}
var Owner_documentClass;
function Owner_document() {
  if (Owner_documentClass === VOID) {
    class $ {
      constructor() {
        Owner_document_instance = this;
        var tmp = this;
        tmp.c6v_1 = lazy(Owner_document$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d6v_1 = lazy(Owner_document$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e6v_1 = lazy(Owner_document$annotations$delegate$lambda);
        this.f6v_1 = null;
        this.g6v_1 = 'null';
      }
      i20() {
        var tmp0 = this.c6v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Owner_document$_get_name_$ref_j64jxw(), null);
        return tmp0.f2();
      }
      h6v(receiver) {
        return receiver.d6t_1;
      }
      k2j(receiver) {
        var tmp = this.h6v(receiver instanceof Owner() ? receiver : THROW_CCE());
        return tmp == null ? null : new (ServerFile())(tmp);
      }
      i6v(receiver, value) {
        return receiver.f6t(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof Owner() ? receiver : THROW_CCE();
        var tmp_0;
        if (value == null ? true : value instanceof ServerFile()) {
          var tmp_1 = value;
          tmp_0 = tmp_1 == null ? null : tmp_1.l2n_1;
        } else {
          tmp_0 = THROW_CCE();
        }
        return this.i6v(tmp, tmp_0);
      }
      h2j() {
        var tmp0 = this.d6v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Owner_document$_get_serializer_$ref_xazbad(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e6v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Owner_document$_get_annotations_$ref_lx4vr3(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'Owner_document', VOID, VOID, [SerializableProperty()]);
    Owner_documentClass = $;
  }
  return Owner_documentClass;
}
var Owner_document_instance;
function Owner_document_getInstance() {
  if (Owner_document_instance === VOID)
    new (Owner_document())();
  return Owner_document_instance;
}
//region block: exports
export {
  get_address as get_address1u6nrhiuagd6j,
  get_birthDate as get_birthDate3aks5n4sb6fcg,
  get_email as get_emailfkvak575ryut,
  get_legalFirstName as get_legalFirstName2vgvsmypb78h2,
  get_legalLastName as get_legalLastName2t4vvvivshuwy,
  get_ownership as get_ownership2ob2423l2ny83,
  get_phoneNumber as get_phoneNumberpnx60x2fk8y,
  prepareOwnerFields as prepareOwnerFieldsjlfj72vly6cj,
  get_ssn as get_ssn1lut1lpw1ztmp,
  get_title as get_title33i95i844yeoj,
};
//endregion

//# sourceMappingURL=OwnerFields.mjs.map
